module.exports = __webpack_public_path__ + "img/alarm-settings.31a1e6bb.svg";